export const TRACKING_DEFAULTS = {
  PAGES_TYPE: {
    DEFAULT: 'pageData',
    EVENT: 'eventData',
  },
  SITETYPE: 'scoober - courier portal web',
  PAGES_GROUP: {
    COURIER: 'courier management',
    DELIVERY: 'delivery dashboard',
    OVERVIEW: 'courier app overview',
    NOTSUPPORTED: 'not supported',
    ORDERHISTORY: 'partner order history',
    TIPSETTINGS: 'tipsVisible',
  },
  EVENT: {
    eventCategory: 'My Restaurant Event',
    eventCategoryNavigation: 'Navigation',
  },
};

type TCommonAttributes = {
  restaurantId?: string;
};

export type COOKIE_CONSENT = 'functional' | 'full';
export type COMPONENT_TYPE =
  | 'dialog'
  | 'form'
  | 'button'
  | 'video'
  | 'alert'
  | 'order'
  | 'list'
  | 'banner'
  | 'courier card'
  | 'boolean'
  | 'toggle'
  | 'sheet'
  | 'link'
  | 'text'
  | 'image'
  | 'icon'
  | 'map'
  | 'select'
  | 'input'
  | 'checkbox'
  | 'radio'
  | 'slider'
  | 'order';

export type TTrackPageViewData<Attributes = {}> = TCommonAttributes & {
  cookieConsent: COOKIE_CONSENT;
  pageGroup: string;
  siteType: string;
  url: string;
  country: string;
  language: string;
  pagePWA: string;
} & Attributes;

export type TTrackEventData<Attributes = {}> = TCommonAttributes & {
  eventCategory: string;
  component_name: string;
  component_type?: COMPONENT_TYPE;
  country: string;
  language: string;
} & Attributes;

export type TTealiumTrackPage = <Attributes>(
  page: string,
  data?: TTrackPageViewData<Attributes>
) => void;

export type TTealiumTrackEvent = <Attributes>(
  event: string,
  data?: TTrackEventData<Attributes>
) => void;

export type TGtmTrackPage = <Attributes>(
  page: string,
  data?: TTrackPageViewData<Attributes>
) => void;

export type TGtmTrackEvent = <Attributes>(
  page: string,
  data?: TTrackPageViewData<Attributes>
) => void;

export type TAnalyticsTrackPage = <Attributes>(
  page: string,
  data?: TTrackPageViewData<Attributes>
) => void;

export type TAnalyticsTrackEvent = <Attributes>(
  event: string,
  data?: TTrackEventData<Attributes>
) => void;
